import React from 'react';

import {ButtonComponentProps} from "../../../../../core/components/misc/buttons/button";
import {BookmakerActionButton} from "../../../../../core/components/odds/bookmaker-action-button/bookmaker-action-button";
import {CurrentOddsModuleRow} from "./current-odds-module.row";
import {observer} from "mobx-react"
import {CurrentOddsModuleComponentProps} from "./current-odds-module";
import classNames from "classnames";
import styles from "../styles/current-odds.module.scss"
import {APP} from "../../../../../core/app/consts";
import {useBookieClick} from "../../../../../infrastructure/hooks/useBookieClick";
import {PartialGameViewModel} from "../../../../../domain/partial-game/models/partial-game-view-model";



export const PreMatchOddsModuleComponent = observer(({controller, betsImpressionParams, showOriginalOdds}: CurrentOddsModuleComponentProps) => {
  const {state, device, terms} = controller;
  const {bookmaker, currentRates, hasPreMatchOdds, hasValidCurrentRates, isOnlyPreMatchOdds, hasValidPreMatchRates, currentLinkModel, gameId, statusGroup, odds} = state;
  const {isSmallView} = device
  const {actionButton} = bookmaker;

  if (!hasValidCurrentRates && !hasPreMatchOdds) {
    return null;
  }

  const {bookieHrefModel, onBookieClick} = useBookieClick(controller, {
    urlLink: bookmaker.link,
    currentLinkModelName: currentLinkModel.name,
    entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[PartialGameViewModel.name],
    entityId: gameId,
    status: statusGroup,
    marketType: odds.lineTypeId,
    bookieId: bookmaker.id,
    bookieName: bookmaker.name,
    widget: APP.GOOGLE_ANALYTICS.SOURCES.currentOdds,
    impressionType: APP.ANALYTICS.BETS_IMPRESSION_TYPES.cta_button,
    hasOdds: true,
    source: APP.ANALYTICS.SOURCES.currentOdds
  });

  const buttonProps: ButtonComponentProps = actionButton && {
    onClick: () => !bookmaker.isDummyBookie && onBookieClick(),
    bookieHrefModel,
    className: classNames(styles.bet_now_button),
    isSmallView: isSmallView,
    bookmaker: bookmaker,
    shouldRenderActionButton: bookmaker?.actionButton,
    betsImpressionParams,
    controller,
  };

  const preMatchRowProps = {
    controller,
    betsImpressionParams,
    rates: currentRates,
    bookmaker: bookmaker,
    title: hasPreMatchOdds && terms.ODDS_COMPARISON_PRE,
    isSmallView: isSmallView,
    isPreMatchOdds: true,
    isLiveMatch: false,
    showOriginalOdds,
  };

  return (
      <div className={classNames(styles.pre_match_odds_module_container, {[styles.is_pre_match_only]: isOnlyPreMatchOdds})}>
        {
          actionButton ? <BookmakerActionButton {...buttonProps}/> : null
        }
        {
          hasValidPreMatchRates ? <CurrentOddsModuleRow {...preMatchRowProps}/> : null
        }
      </div>
  )
});

